import { api } from "assets/scripts/utilities/api-clients";

export const index = async (options) => {
  const response = await api.get("/kam/payments-received", options);

  return response;
};

export const get = async (id) => {
  const response = await api.get(`/kam/payments-received/${id}`);

  return response;
};

export const getPaymentByNumber = async (number) => {
  const response = await api.get(`/kam/payments-received-number`, {
    params: { number },
  });

  return response;
};
